import _ from "lodash";
import { useEffect } from "react";
import { useState } from "react";
import {
  CircularProgressbar,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getLevelDetailReq,
  getLevelDetailResponseClear,
  getModuleListingClearBroker,
  getSelectedCatId,
  getModuleListingClear,
  getMyLearningPaths,
  getCheckListInsert,
  getMyLearningPathsClear,
} from "../../redux/courses/actions";
import {
  convertTimeFormat,
  convertTimeInHourAndMin,
  getEntityType,
  getProcureInfo,
  SessionKeys,
} from "../../utils/AppUtils";
import BreadCrumbComponent from "../../components/NewDesign/Misc/BreadCrumb/BreadCrumbComponent";
import ShimmerScreen from "../../components/Layouts/ShimmerScreen";
import { Tab, Tabs } from "react-bootstrap";
import DetailPageDiscussComponent from "../../components/NewDesign/DetailPage/DetailPageDiscuss/DetailPageDiscussComponent";
import LPdetailComp from "../../components/b2cComponents/LPDetailComp";
import CartBandComponent from "../../components/NewDesign/DetailPage/CartBand/CartBandComponent";
import CartPopUpComponent from "../../components/NewDesign/DetailPage/CartPopUp/CartPopUpComponent";
import useLogin from "../../custom-hooks/useLogin";
import DetailPageBannerHeaderComponent from "../../components/NewDesign/DetailPage/DetailPageBannerHeader/DetailPageBannerHeaderComponent";
import Loader from "../../components/Loader/Loader";
import RightPanelComponent from "../../components/NewDesign/DetailPage/DetailPageRightPanel/RightPanelComponent";
import { useTranslation } from "react-i18next";
import NotFoundComponent from "../../components/NewDesign/NotFound/NotFoundComponent";
import Page from "../../finwell/pages/Page";
import "./LPDetailPage.scss";
import SessionRequest from "../../finwell/components/home/SessionRequest";
const LPDetailPage = () => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const { t } = useTranslation();
  const toggleMenu = () => {
    setIsOpenMenu(!isOpenMenu);
  };
  const closeMenu = () => {
    setIsOpenMenu(false);
  };
  const dispatch = useDispatch();
  const { isLoggedIn } = useLogin();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  // const level_id = params.get('level_id');
  // const lp_id = params.get('lp_id');
  // const fromLevel = params.get('is_level')
  // const source = params.get('source')
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const c = params.get("c");
  let decodedString = atob(c);
  let paramsReq = JSON.parse(decodedString);
  const level_id = paramsReq?.level_id;
  const lp_id = paramsReq?.lp_id;
  const fromLevel = paramsReq?.is_level;
  const source = paramsReq?.source;
  const ob_lp_flag = paramsReq?.ob_lp_flag;
  const is_home = paramsReq?.is_home;
  const from_sub = paramsReq?.from_sub;
  const provider_id = paramsReq?.provider_id;
  const provider_name = paramsReq?.provider_name;

  const webview = params.get("webView");

  const [isLoading, setIsLoading] = useState(false);
  const [closeChildModal, setCloseChildModal] = useState(true);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const levelDetails = useSelector((state) => state.courses.getLevelDetail);
  const myLearningPathsData = useSelector(
    (state) => state.courses.myLearningPaths
  );
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const [levelDetail, setLevelDetail] = useState();
  const [learningPathData, setLearningPathData] = useState({});
  const [headerProdData, setHeaderProdData] = useState({});

  // const [fromLevel, setFromLevel] = useState(false);

  const [showShimmer, setShowShimmer] = useState(false);
  const [key, setKey] = useState("learn");
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const [coachUrl, setCoachUrl] = useState("");


  const [breadCrumbData, setBreadCrumbData] = useState([
    {
      name: provider_name
        ? authBroker?.payload?.user?.config?.partner_menu_text !== undefined &&
          !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)
          ? authBroker?.payload?.user?.config?.partner_menu_text
          : "Partners"
        : is_home
          ? "Home"
          : from_sub
            ? "Subscription"
            : t("learn"),
      active: false,
      link: "",
      isLoading: false,
    },
    { name: t("Action Path"), active: false, link: "", isLoading: false },
    { name: "-", active: false, link: "", isLoading: true },
  ]);

  const [purchasedInfo, setPurchasedInfo] = useState({});
  const [isPaid, setIsPaid] = useState(false);
  const [price, setPrice] = useState(false);
  const [isInCart, setIsInCart] = useState(false);
  const addToCartRes = useSelector((state) => state.product.addToCart);
  const [completedCount,setCompletedCount] = useState(0);

  useEffect(() => {
    if (fromLevel === "true") {
      setShowShimmer(true);
      window.scrollTo(0, 0);
      dispatch(
        getLevelDetailReq({
          module: "getLevelDetail",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            program_id: lp_id,
            level_id: level_id,
            language: activeLanguage ? activeLanguage : "",
          },
        })
      );
    } else {
      setShowShimmer(true);
      callLPDetailApi();
    }
  }, [lp_id, level_id, fromLevel, activeLanguage]);

  const callLPDetailApi = () => {
    if (source === "xsel" || source === "ecom") {
      dispatch(
        getMyLearningPaths({
          module: "getMyLearningPathsEcom",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            is_onboarding: 0,
            id: lp_id,
          },
        })
      );
    } else {
      dispatch(
        getMyLearningPaths({
          module: "getMyLearningPaths",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            assigned: 0,
            lp_id: lp_id,
            is_onboarding: ob_lp_flag === 2 ? 1 : 0,
            language: activeLanguage ? activeLanguage : "",
          },
        })
      );
    }
  };

  const getFormatedData = (learning) => {
    let sendFlag = false;
    console.log("lpDetail: ", learning);
    learning.duration = convertTimeFormat(_.toNumber(learning.duration), true);
    if (learning.coursesList) {
      learning.is_manager_checklist = false;
      for (let [index, course] of learning.coursesList.entries()) {
        let currentCourse = course;
        let nextCourse = learning.coursesList[index + 1];
        console.log("CURRENT COURSE", currentCourse);
        console.log("NEXT COURSE", nextCourse);
        if (learning.sequence === 1) {
          console.log("is sequence");
          if (index === 0) {
            currentCourse.isLock = false;
          }
          currentCourse.isLock =
            currentCourse.isLock === false ? currentCourse.isLock : true;
          if (currentCourse.crs_progress > 0) {
            console.log("CURRENT PROGRESS IS MORE THAN ZERO");
            // currentCourse.isLock = currentCourse.crs_progress >= 100 ? false;
            if (index !== learning.coursesList.length - 1) {
              console.log("INDEX IS NOT LAST");
              nextCourse.isLock =
                _.toNumber(currentCourse.crs_progress) >= 100 &&
                  !currentCourse.isLock
                  ? false
                  : true;
              console.log("NEXT COURSE ISLOCK", nextCourse.isLock);
            }
          }
        } else {
          currentCourse.isLock = currentCourse.isLock
            ? currentCourse.isLock
            : false;
        }
        let isSecondsFlag =
          currentCourse.durationUnit != "minutes" ? true : false;
        currentCourse.duration = convertTimeFormat(
          _.toNumber(currentCourse.duration),
          isSecondsFlag
        );
        currentCourse.durationUnit = "";
        // console.log("detaiiii", course)

        // will uncomment this when checklist is available in B2C
        if (index < learning.coursesList.length - 1) {
          if (
            !currentCourse?.is_checklist_approved &&
            currentCourse?.is_checklist_present
          ) {
            nextCourse.isLock = nextCourse.crs_progress <= 100 ? true : false;
          } else if (
            currentCourse?.is_checklist_approved &&
            currentCourse?.is_checklist_present
          ) {
            nextCourse.isLock = false;
          }

          if (currentCourse.is_checklist_present) {
            learning.is_manager_checklist = true;
          }
        }

        if (
          !currentCourse?.is_checklist_approved &&
          currentCourse?.is_checklist_present &&
          !sendFlag
        ) {
          if (
            currentCourse.crs_progress >= 100 &&
            !currentCourse.isLock &&
            index !== learning.coursesList.length - 1
          ) {
            dispatch(
              getCheckListInsert({
                module: "checklist-insert",
                postData: {
                  token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                  lp_id: learning?.id,
                  entity_id:
                    currentCourse.source === "broker"
                      ? currentCourse.id
                      : currentCourse?.crscd,
                  entity_type: !currentCourse?.is_level
                    ? currentCourse.entity_type
                    : "level",
                },
              })
            );
            sendFlag = true;
          }
        }
      }
      for (let course of learning.coursesList) {
        course.is_manager_checklist = learning.is_manager_checklist;
      }

      let priceInfo = getProcureInfo(learning.purchased_info);
      priceInfo.isAddToCart = learning.is_addtocart;
      console.log("PRICE INFO", priceInfo);
      let tags = [];
      let logoURL = "";
      let logoAltText = "LP";
      if (!_.isEmpty(learning.provider)) {
        tags.push(learning.provider.provider_display_name);
        logoURL = learning.provider.provider_img;
      }
      tags.push("Action Path");
      // if (learning.provider?.provider_display_name) {
      //   tags.push(learning.provider.provider_display_name);
      // }
      // tags.push(getEntityType(learning.entity_type));

      // if (learning.entity_type === "course" && learning.lessons) {
      //   tags.push(
      //     `${learning.lessons} Module${learning.lessons > 1 ? "s" : ""}`
      //   );
      // } else if (learning.entity_type === "level") {
      // }

      if (learning.learningpath_count) {
        tags.push(
          `${learning.learningpath_count} Action Path${learning.learningpath_count > 1 ? "s" : ""
          }`
        );
      }

      if (learning.course_count > 0)
        tags.push(
          `${learning.course_count} Step${learning.course_count > 1 ? "s" : ""
          }`
        );
      else if (learning.video_count > 0)
        tags.push(
          `${learning.video_count} Video${learning.video_count > 1 ? "s" : ""}`
        );
      else if (learning.event_count > 0)
        tags.push(
          `${learning.event_count} Event${learning.event_count > 1 ? "s" : ""}`
        );
      if (learning.duration) tags.push(learning.duration);

      // if (!isLoggedIn) priceInfo.isFree = false;
      setHeaderProdData({
        id: learning.ecom_id,
        title: learning.prgm_nm,
        logoURL: logoURL,
        logoAltText,
        bannerURL: learning.thumbnail,
        tagsArray: tags,
        description: learning.prgm_description,
        duration: "",
        view: learning.views,
        price: priceInfo.price,
        isPaid: priceInfo.isPurchased,
        priceInfo: priceInfo,
        purchaseInfo: learning.purchased_info,
        banner: learning.banner,
        priceText: `Price:  ${learning?.purchased_info?.currency_symbol}${learning?.purchased_info?.selling_price} `,
      });
      // alert(JSON.stringify(learning.purchased_info.offer_ends_on_text))

      if (
        (source === "xsel" || source === "ecom") &&
        !_.isEmpty(learning.purchased_info)
      ) {
        const purchased_info = learning.purchased_info;
        console.log("courseDetailEcom", purchased_info);
        if (
          purchased_info.is_purchased ||
          _.toNumber(purchased_info.selling_price) == 0
        ) {
          setIsPaid(false);
          setPrice(0);
        } else {
          setIsPaid(true);
          setPrice(_.toNumber(purchased_info.selling_price));
          for (let course of learning.coursesList) {
            course.isLock = true;
          }
        }
        setIsInCart(learning.is_addtocart);
        if (!isLoggedIn) {
          for (let course of learning.coursesList) {
            course.isLock = true;
          }
        }
      }
    }

    return learning;
  };

  useEffect(() => {
    // console.log('LearningPath', myLearningPathsData)
    if (!_.isEmpty(myLearningPathsData)) {
      setShowShimmer(false);
      if (myLearningPathsData.status === "success") {
        setIsLoading(false);
        if (!_.isEmpty(myLearningPathsData.payload.payload)) {
          let learning = _.cloneDeep(myLearningPathsData.payload.payload);
          console.log("learningPath", learning);

          let learningData = getFormatedData(learning);
          console.log("learningpathdata", learningData);
          for (let record of learningData.coursesList) {
            let checklistArray = [];
            record.clInfo = {};
            if (
              record.is_checklist_present &&
              !_.isEmpty(record.checklist_data) &&
              !_.isEmpty(record.checklist_data.checklist_title)
            ) {
              // alert(JSON.stringify(record.checklist_data.checklist_title))
              checklistArray = record.checklist_data.checklist_title;
              let clData = record.checklist_data;
              record.clInfo = {
                lp_name: clData.prgm_nm,
                course_or_level: clData.type,
                course_name: clData.crs,
                course_completion_date: clData.course_completion_date
                  ? clData.course_completion_date
                  : "",
                rea_name: clData.user_name,
                title_array: checklistArray,
              };
              // if (learning.id == 16548) alert(JSON.stringify(record))
            }
          }
          // alert(JSON.stringify(learningData))

          let breadCData = [
            {
              name: provider_name
                ? authBroker?.payload?.user?.config?.partner_menu_text !==
                  undefined &&
                  !_.isEmpty(
                    authBroker?.payload?.user?.config?.partner_menu_text
                  )
                  ? authBroker?.payload?.user?.config?.partner_menu_text
                  : "Partners"
                : is_home
                  ? "Home"
                  : from_sub
                    ? "Subscription"
                    : t("learn"),
              active: false,
              link: provider_name
                ? "/our-partners"
                : is_home
                  ? "/home"
                  : from_sub
                    ? "/subscription"
                    : "/learn/learningpath",
              isLoading: false,
            },
          ];
          let paramsReq = {
            provider_id: provider_id,
            provider_name: provider_name,
          };
          let jsonString = JSON.stringify(paramsReq);
          let encodedUrl = btoa(jsonString);
          if (provider_name) {
            breadCData.push({
              name: provider_name,
              active: false,
              link: `/partner-detail?c=${encodedUrl}`,
              isLoading: false,
            });
          }

          breadCData.push({
            name: t("Action Path"),
            active: false,
            link: provider_name
              ? `/partner-detail/learningpath/?c=${encodedUrl}`
              : "/learn/learningpath?tab=3",
            isLoading: false,
          });

          breadCData.push({
            name: learningData.prgm_nm,
            active: true,
            link: "",
            isLoading: false,
          });

          setBreadCrumbData(breadCData);
          let actionPathDataTemp = _.cloneDeep(learningData);
          let list = _.cloneDeep(learningData?.coursesList)
          console.log("coursesListSort11: ",list)
          const sortedList = [...list].sort((a, b) => Number(b.crs_progress) - Number(a.crs_progress));
          console.log("coursesListSort: ",sortedList)
            // Find the last course where crs_progress is 100 and set current = true
            const lastCompletedIndex = [...sortedList].reverse().findIndex(course => Number(course.crs_progress) === 100);
            if (lastCompletedIndex !== -1) {
            // Adjust index because of reverse()
            const actualIndex = sortedList.length - 1 - lastCompletedIndex;
            sortedList[actualIndex].current = true;
            } else if (sortedList.length > 0) {
            // If none are complete, mark the first as current
            sortedList[0].current = true;
            }
          actionPathDataTemp.coursesListSort = sortedList;


            // Count the number of courses with crs_progress === 100
            const completedCoursesCount = list.filter(course => Number(course.crs_progress) === 100).length;
            setCompletedCount(completedCoursesCount);
          console.log(learningData);
          setLearningPathData(actionPathDataTemp);
        }
      }
      dispatch(getMyLearningPathsClear());
    }
  }, [myLearningPathsData]);

  useEffect(() => {
    console.log("levelDetails: ", levelDetails);

    if (!_.isEmpty(levelDetails)) {
      setShowShimmer(false);
      if (levelDetails?.status === "success") {
        if (!_.isEmpty(levelDetails?.payload?.payload)) {
          const learning = _.cloneDeep(levelDetails?.payload?.payload);
          let learningData = getFormatedData(learning);

          let paramsReq = {
            lp_id: lp_id,
            is_level: "false",
            source: source,
          };

          let breadCData = [
            {
              name: provider_name
                ? authBroker?.payload?.user?.config?.partner_menu_text !==
                  undefined &&
                  !_.isEmpty(
                    authBroker?.payload?.user?.config?.partner_menu_text
                  )
                  ? authBroker?.payload?.user?.config?.partner_menu_text
                  : "Partners"
                : is_home
                  ? "Home"
                  : from_sub
                    ? "Subscription"
                    : t("learn"),
              active: false,
              link: provider_name
                ? "/our-partners"
                : is_home
                  ? "/home"
                  : from_sub
                    ? "/subscription"
                    : "/learn/learningpath",
              isLoading: false,
            },
          ];

          paramsReq.provider_id = provider_id;
          paramsReq.provider_name = provider_name;

          let jsonString = JSON.stringify(paramsReq);
          let encodedUrl = btoa(jsonString);
          if (provider_name) {
            breadCData.push({
              name: provider_name,
              active: false,
              link: `/partner-detail?c=${encodedUrl}`,
              isLoading: false,
            });
          }

          breadCData.push({
            name: t("Action Path"),
            active: false,
            link: provider_name
              ? `/partner-detail/learningpath/?c=${encodedUrl}`
              : "/learn/learningpath?tab=3",
            isLoading: false,
          });

          breadCData.push(
            {
              name: learningData.lp_name,
              active: false,
              link: `/lpDetail?c=${encodedUrl}`,
              isLoading: false,
            },
            {
              name: t("Level"),
              active: false,
              link: `/lpDetail?c=${encodedUrl}`,
              isLoading: false,
            },
            {
              name: learningData.prgm_nm,
              active: true,
              link: "",
              isLoading: false,
            }
          );

          setBreadCrumbData(breadCData);

          setLearningPathData(learningData);
        }
      }
    }
  }, [levelDetails]);

  useEffect(() => {
    return () => {
      dispatch(getLevelDetailResponseClear());
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(addToCartRes)) {
      setIsLoading(false);
      callLPDetailApi();
    }
  }, [addToCartRes]);

  useEffect(() => {
    let userDetailResLocal = userDetailRes;
    console.log("userDetailResLocal", userDetailResLocal);
    if (!_.isEmpty(userDetailResLocal)) {
      if (userDetailResLocal?.status === "success") {
        let journey = userDetailResLocal?.payload?.payload?.money_journey;
        setCoachUrl(journey?.coach);

      }
    }
  }, [userDetailRes]);

  const currentStep = 1;
  return (
    <>
      <Loader start={isLoading} />
      <Page>
        {learningPathData?.status === "over-due" ? (
          <NotFoundComponent
            width={400}
            height={419}
            showBtn={false}
            showMsg={true}
            msgLine={
              "You can not access this content anymore as it is overdue now. "
            }
          />
        ) : (

          <>
            <section className="action-sec">

              <LPdetailComp
                contentList={learningPathData?.coursesList}
                lpDetail={learningPathData}
                showShimmer={showShimmer}
                fromPage={"lp"}
                isMobile={false}
              />


              <div className="right-side">
                <div className="circle-wraplp">

                  <div className="box-progress">
                    <div style={{ width: 90, height: 90 }}>
                    <CircularProgressbar
                          value={learningPathData?.prgm_progress}
                          text={`${learningPathData?.prgm_progress?.toFixed(0)} %`}
                          strokeWidth={16}
                          styles={buildStyles({
                            rotation: 0.25,
                            strokeLinecap: 'round',
                            textSize: '1rem',
                            pathTransitionDuration: 0.5,
                            pathColor: 'var(--color-element-1, #415385)',
                            textColor: '#474747',
                            fontFamily: '"PwC Helvetica Neue", sans-serif',
                            trailColor: '#D2D7E2',
                            backgroundColor: '#fff',
                            textStyle: {
                              fontFamily: '"PwC Helvetica Neue", sans-serif', // 👈 Apply custom font
                              fontWeight: 500,
                            }
                          })}
                        />
                    </div>

                  </div>
                </div>
                {/* <ul>
                {learningPathData?.coursesList?.map((item, index) => (
                  <li key={index}>
                      {item.name}
                  </li>
                ))}
                </ul> */}
                <div className="progress-container mt-2rem">
                  <ul
                    className="vertical-progress"
                    style={{ "--step-index": learningPathData?.coursesListSort?.length === 1 ? 0 : completedCount - 1 }}
                  >
                    {learningPathData?.coursesListSort?.map((item, index) => {
                      const isCurrent = index === currentStep;
                      const isBefore = index < currentStep;

                      return (
                        <li
                          key={index}
                          className={`step-item ${item?.current || learningPathData?.coursesList?.length === 1 ? "current" : ""} ${isBefore ? "completed" : ""
                            }`}
                        >
                          <span className="text eclipse-one-line" title={item.name}>{item.name}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>

                <SessionRequest from="right" coach={coachUrl} />

              </div>
            </section>
          </>
        )}
        {
          // <CartPopUpComponent
          // 	isOpen={isOpen}
          // 	productData={headerProdData}
          // 	closeAction={() => setIsOpen(false)}
          // 	isSubscription={false}
          // />
        }
      </Page>
    </>
  );
};

export default LPDetailPage;
